import { render, staticRenderFns } from "./CounselingQuestionTexts.vue?vue&type=template&id=57a44dc0&"
import script from "./CounselingQuestionTexts.vue?vue&type=script&lang=ts&"
export * from "./CounselingQuestionTexts.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports